export default "__VITE_ASSET__BNHQ0lnp__"